import { render, staticRenderFns } from "./IncCartProducts.vue?vue&type=template&id=5936c71c"
import script from "./IncCartProducts.vue?vue&type=script&lang=js"
export * from "./IncCartProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports